import { Action, Dispatch } from 'redux';
import { get } from 'components/Shared/server';
import { ConservatoryMakeProductModel } from 'models/ConservatoryMakeProductModel';

const RESPONSESTATUS_SUCCESS = 200;

export const GUIDE_MAKE_DATA_LOADING = 'GUIDE_MAKE_DATA_LOADING';
export const GUIDE_MAKE_DATA_LOADED = 'GUIDE_MAKE_DATA_LOADED';
export const GUIDE_MAKE_PRODUCT_SELECTED = 'GUIDE_MAKE_PRODUCT_SELECTED';
export const GUIDE_MAKE_VALID = 'GUIDE_MAKE_VALID';
export const GUIDE_MAKE_INVALID = 'GUIDE_MAKE_INVALID';

export interface ConservatoryMakeAction extends Action {
  articleGroup: string;
  products: ConservatoryMakeProductModel[];
}

export interface ConservatoryMakeSelectProductAction extends Action {
  productId: string;
}

export const guideMakeValid = () => ({
  type: GUIDE_MAKE_VALID
});

export const guideMakeInValid = () => ({
  type: GUIDE_MAKE_INVALID
});

export const guideMakeProductSelected = (productId: string) => ({
  type: GUIDE_MAKE_PRODUCT_SELECTED,
  productId
});

export const guideMakeDataloaded = (makeProducts?: ConservatoryMakeProductModel[] | undefined) => ({
  type: GUIDE_MAKE_DATA_LOADED,
  products: makeProducts
});

export const guideMakeDataloading = () => ({
  type: GUIDE_MAKE_DATA_LOADING,
  products: undefined
});

export const guideMakeFetchData = (articleGroup: string, season: string) => {
  return (dispatch: Dispatch) => {
    dispatch(guideMakeDataloading());

    if (articleGroup.length < 1) {
      dispatch(guideMakeDataloaded(undefined));
      return;
    }

    void get({
      url: `/conservatory/getmakedata?artGrp=${articleGroup}&season=${encodeURI(season)}`
    })
      .then(response => {
        if (response.status !== RESPONSESTATUS_SUCCESS) {
          dispatch(guideMakeDataloaded(undefined));
          return;
        }

        return response.json();
      })
      .then((data: ConservatoryMakeProductModel[]) => {
        dispatch(guideMakeDataloaded(data));
      });
  };
};
